var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"left-top"},[_c('section')]),_c('div',{staticClass:"left-bottom"},[_c('section')])]),_c('div',{staticClass:"flex-box"},[_c('div',{staticClass:"right-top"},[_c('section')]),_c('div',{staticClass:"right-bottom"},[_c('section')])])])
}]

export { render, staticRenderFns }